import React from "react";
import LinkItem from "./LinkItem";
import {
  FaInstagram,
  FaGithub,
  FaLinkedin,
  FaGlobe,
  FaHackerrank,
  FaFacebook,
  FaEnvelope,
  FaStackOverflow,
  FaStickyNote,
  FaFileCode,
} from "react-icons/fa";
import { SiKaggle, SiLeetcode } from "react-icons/si";

const links = [
  { label: "Portfolio", url: "https://myportfoliowebsite-hira2415.netlify.app/", icon: FaGlobe },
  { label: "GitHub", url: "https://github.com/HiraNawaz2415", icon: FaGithub },
  { label: "LinkedIn", url: "https://www.linkedin.com/in/hira-nawaz-544632348/", icon: FaLinkedin },
  { label: "Instagram", url: "https://instagram.com/hira_nawaz15", icon: FaInstagram },
  { label: "HackerRank", url: "https://www.hackerrank.com/profile/nawazhira48", icon: FaHackerrank },
  { label: "Kaggle", url: "https://www.kaggle.com/hiranawaz2415", icon: SiKaggle },
  { label: "Facebook", url: "https://www.facebook.com/share/19W5i4qj6N/", icon: FaFacebook },
  { label: "Email", url: "mailto:nawazhira48@gmail.com", icon: FaEnvelope },
  { label: "Notes", url: "https://noteshub15.netlify.app/", icon: FaStickyNote }, // or FaNotesMedical
  { label: "LeetCode", url: "https://leetcode.com/u/hiranawaz2415/", icon: SiLeetcode },
  {
    label: "Stack Overflow",
    url: "https://stackoverflow.com/users/23370218/hira-nawaz",
    icon: FaStackOverflow,
  },
  {
    label: "Streamlit App",
    url: "https://share.streamlit.io/user/hiranawaz2415",
    icon: FaFileCode,
  },
];

const LinkList = () => {
  return (
    <div className="w-full max-w-sm mt-6 space-y-4">
      {links.map((link, index) => (
        <LinkItem key={index} label={link.label} url={link.url} Icon={link.icon} />
      ))}
    </div>
  );
};

export default LinkList;
